// Wait announced by an HTTP 429 "Retry-After" header (delay in seconds or HTTP date), in seconds;
// null when the header is absent, unreadable or already past.
export function retryAfterSeconds(value, now = Date.now()) {
  if (value == null) return null;
  const text = String(value).trim();
  if (/^\d+$/.test(text)) {
    const seconds = Number(text);
    return seconds > 0 ? seconds : null;
  }
  const date = Date.parse(text);
  if (Number.isNaN(date)) return null;
  const seconds = Math.ceil((date - now) / 1000);
  return seconds > 0 ? seconds : null;
}

// Minutes shown to the visitor: rounded up, never 0.
export const waitMinutes = (seconds) => Math.max(1, Math.ceil(seconds / 60));
